var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTwitterX = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 23 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.927 10.491 18.511 4h-1.323l-4.849 5.636L8.467 4H4l5.856 8.523L4 19.33h1.323l5.12-5.952 4.09 5.952H19l-6.073-8.839Zm-1.812 2.107-.594-.849-4.72-6.753h2.032l3.81 5.45.593.849 4.953 7.084h-2.033l-4.041-5.78v-.001Z"
})));
export default SvgTwitterX;